import { actionAuth } from "../../redux/actions/auth";

export const AuthContainer = (dispatch) => ({
  logout: () => {
    dispatch(actionAuth.Logout());
  },
});
